<ng-template #popContent>
  <div class="d-flex justify-content-end mb-1">
    <a
      class="btn btn--link btn--no-shadow btn--no-padding btn--small"
      (click)="dismiss($event)"
    >
      {{ dismissLinkText() }}
    </a>
  </div>

  <ab-add-slack-callout
    *ngIf="className === 'AddSlack'"
    [project]="project"
    (dismissAndFollowLink)="dismissAndFollowLink($event)"
  >
  </ab-add-slack-callout>

  <ab-name-first-project-callout
    *ngIf="className === 'NameFirstProject'"
    [project]="project"
    (dismissAndFollowLink)="dismissAndFollowLink($event)"
  >
  </ab-name-first-project-callout>

  <ab-show-aggregations-callout
    *ngIf="className === 'ShowAggregations'"
    [group]="group"
    (dismiss)="dismiss($event)"
  >
  </ab-show-aggregations-callout>

  <ab-add-apm-callout
    *ngIf="className === 'AddApm'"
    [project]="project"
    (dismiss)="dismiss($event)"
  >
  </ab-add-apm-callout>

  <ab-add-deploys-callout
    *ngIf="className === 'AddDeploys'"
    [project]="project"
    (dismiss)="dismiss($event)"
  >
  </ab-add-deploys-callout>

  <ab-show-onboarding-checklist-callout
    *ngIf="className === 'ShowOnboardingChecklist'"
    [project]="project"
  >
  </ab-show-onboarding-checklist-callout>
</ng-template>

<div
  #popoverInstance="ngbPopover"
  [ngbPopover]="popContent"
  triggers="manual"
  placement="bottom"
></div>
